import { EVENTS } from "../../../js/constants";

class Flyout {
  /**
   * @param {HTMLElement} element - flyout
   */
  constructor(element) {
    this.element = element;
    this.openClass = "is-open";
    this.closeButton = this.element.querySelector(".js-Flyout-closeButton");
    this._close = this._close.bind(this);
    this._onToggleEvent = this._onToggleEvent.bind(this);
    this._bind();
  }

  /**
   * binds event listeners
   *
   * @private
   */
  _bind() {
    this.closeButton.addEventListener("click", this._close);
    this.element.addEventListener(EVENTS.FLYOUT_OPEN, this._onToggleEvent);
  }

  /**
   * toggles flyout visibility based on `FLYOUT_OPEN` event
   * this makes it possible to change visibility from outside the component
   * additionally it calculates the proper position of the arrow
   *
   * @param {object} event
   * @param {object} event.detail
   * @private
   */
  _onToggleEvent({ detail }) {
    const { triggeredElement, isOpen } = detail;
    this.element.classList.toggle(this.openClass, isOpen);

    if (isOpen) {
      const flyoutXPosition = this.element.getBoundingClientRect().x;
      const { x: triggeredElementXPosition, width: triggeredElementWidth } =
        triggeredElement.getBoundingClientRect();

      if (triggeredElementXPosition !== flyoutXPosition) {
        const arrowLeftPosition =
          triggeredElementXPosition -
          flyoutXPosition +
          triggeredElementWidth / 2;

        /* 10 is based on the default font size from the `global.css` */
        this.element.style.setProperty(
          "--Flyout--withArrow-position-left",
          `${arrowLeftPosition / 10}rem`
        );
      }
    }
  }

  /**
   * closes flyout and dispatches `FLYOUT_OPEN` event
   *
   * @private
   */
  _close() {
    this.element.classList.remove(this.openClass);
    this.element.dispatchEvent(
      new CustomEvent(EVENTS.FLYOUT_OPEN, {
        detail: { isOpen: false },
      })
    );
  }
}

export default Flyout;
